// extracted by mini-css-extract-plugin
export default {"option-content__picture":"lA9Yv","option-content__img":"bQT1C"};